import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from 'src/common/Loader';
import ROUTE from 'src/utils/routeConstants';
import { isTyreManagementV2Enabled } from 'src/utils/tyreManagementFeature';
import VehicleCreatePage from './VehicleCreatePage';

const VehicleCreateRoute = () => {
  const { appSettings, appSettingsLoaded } = useSelector((state) => state.settings);

  if (!appSettingsLoaded) return <Loader />;

  if (!isTyreManagementV2Enabled(appSettings)) {
    return <Redirect to={ROUTE.vehicles} />;
  }

  return <VehicleCreatePage />;
};

export default VehicleCreateRoute;
